// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.chart-container[data-v-45a03ef0] {\n  background-color: #fff;\n  border: 1px solid transparent;\n  border-radius: 8px;\n  box-shadow: 0 2px 3px 0 hsla(0, 0%, 51%, .1);\n  padding: 24px;\n  width: 100%;\n  height: 400px; /* Set desired height here */\n  margin-bottom: 30px;\n}\n.chartjs-size-monitor[data-v-45a03ef0] {\n  position: absolute;\n  inset: 0px;\n  overflow: hidden;\n  pointer-events: none;\n  visibility: hidden;\n  z-index: -1;\n}\n\n", ""]);
// Exports
module.exports = exports;
